import { ChangeDetectionStrategy, Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
    selector: 'app-standard-search-box',
    templateUrl: './standard-search-box.component.html',
    styleUrls: ['./standard-search-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class StandardSearchBoxComponent implements OnInit, OnDestroy {
    @Output() public searchTextChanged = new EventEmitter<string>();

    private searchText$: Subject<string> = new Subject();
    private subscription = new Subscription();

    public ngOnInit(): void {
        this.subscription.add(
            this.searchText$.pipe(debounceTime(700)).subscribe((searchText) => {
                this.searchTextChanged.emit(searchText);
            })
        );
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public onKeyUp(event: any) {
        this.searchText$.next(event.target.value);
    }
}
